
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/california-traffic-tickets",
      function () {
        return require("private-next-pages/california-traffic-tickets.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/california-traffic-tickets"])
      });
    }
  